import { useRef, useCallback } from 'react';

/**
 * Hook pro swipe přepínání tabů na mobilu.
 * @param {string[]} tabIds — pole ID tabů v pořadí
 * @param {string} activeTab — aktuálně aktivní tab
 * @param {function} setTab — setter pro změnu tabu
 * @param {number} threshold — minimální swipe vzdálenost v px (default 60)
 * @returns {{ onTouchStart, onTouchEnd }} — props pro wrapping element
 */
export default function useSwipeTabs(tabIds, activeTab, setTab, threshold = 60) {
    const startX = useRef(null);
    const startY = useRef(null);

    const onTouchStart = useCallback((e) => {
        startX.current = e.touches[0].clientX;
        startY.current = e.touches[0].clientY;
    }, []);

    const onTouchEnd = useCallback((e) => {
        if (startX.current == null) return;
        const dx = e.changedTouches[0].clientX - startX.current;
        const dy = e.changedTouches[0].clientY - startY.current;
        startX.current = null;
        // Ignoruj vertikální swipe (scroll)
        if (Math.abs(dy) > Math.abs(dx)) return;
        if (Math.abs(dx) < threshold) return;

        const idx = tabIds.indexOf(activeTab);
        if (idx === -1) return;

        if (dx < 0 && idx < tabIds.length - 1) {
            // Swipe doleva → další tab
            setTab(tabIds[idx + 1]);
        } else if (dx > 0 && idx > 0) {
            // Swipe doprava → předchozí tab
            setTab(tabIds[idx - 1]);
        }
    }, [tabIds, activeTab, setTab, threshold]);

    return { onTouchStart, onTouchEnd };
}
